import { toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-59028e4c")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.percentage)
    ? (_openBlock(), _createBlock("span", {
        key: 0,
        class: ["p-text-nowrap p-mr-2 p-px-1 kpi-tag", {
      best: _ctx.best,
      [_ctx.normalizedName]: true,
    }]
      }, _toDisplayString(_ctx.name) + ": " + _toDisplayString(_ctx.value ? `${(_ctx.value * 100).toFixed(2)}%` : "--"), 3))
    : (_openBlock(), _createBlock("span", {
        key: 1,
        class: ["p-text-nowrap p-mr-2 p-px-1 kpi-tag", {
      best: _ctx.best,
      [_ctx.normalizedName]: true,
    }]
      }, _toDisplayString(_ctx.name) + ": " + _toDisplayString(_ctx.value ? _ctx.$toShortNumber(_ctx.value) : "--"), 3))
})